import Swiper from 'swiper/bundle';

if ($(".slider-links.swiper-container").length > 0) {
    const slider_links_swiper = new Swiper(".slider-links.swiper-container", {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        grabCursor: true,
        simulateTouch: true,
        navigation: {
            nextEl: ".links-slider .swiper-button-next",
            prevEl: ".links-slider .swiper-button-prev",
        },
        pagination: {
            el: ".links-slider .swiper-pagination",
            clickable: true,
        }
    });
}


